/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { getDocumentosEmpleadosParams } from 'api/catalogos/documentosEmpleados';
import { checkToken } from 'api/utils';
import { documentoEmpleadoPermission } from 'components/Catalogos/Empleado/Documentos';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import { getModelPermission } from 'utils/permission';

const ExpedienteDocumentosEmpleados = ({
  currentEmpleado,
  documentos,
}) => {
  const [documentosEmpleados, setDocumentosEmpleados] = useState([]);

  const getPermissions = getModelPermission(
    documentoEmpleadoPermission.permissionModel,
    documentoEmpleadoPermission.catalogsModels,
    documentoEmpleadoPermission.tabsModels,
    false,
  );

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      await checkToken();
      const _documentosEmpleados = await getDocumentosEmpleadosParams({ empleado: currentEmpleado });
      if (mounted) {
        setDocumentosEmpleados(_documentosEmpleados);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setDocumentosEmpleados([]);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const columns = [
    {
      titleText: 'Documento',
      dataIndex: 'tipo_de_documento',
      key: 'tipo_de_documento',
      width: 300,
      render: (val) => documentos.find((e) => e.id === val)?.nombre,
    },
    {
      titleText: 'Entregado por el Empleado',
      dataIndex: 'entregado',
      key: 'entregado',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 200,
    },
  ];

  return (
    <Table
      cols={columns}
      data={documentosEmpleados}
      permission={getPermissions}
      allowExportPDF={false}
    />
  );
};

export default ExpedienteDocumentosEmpleados;
